import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { InputCheckboxListInterface, InputCheckboxListOption } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-input-checkbox-list',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,

  ],
  templateUrl: './input-checkbox-list.component.html',
  styleUrls: [
    '../../styles/input-base.css',
    './input-checkbox-list.component.css',
  ],
})
export class InputCheckboxListComponent {
  @Input()
  public formData!: InputCheckboxListInterface;

  @Input()
  public isLoading: boolean = false;

  public get control(): FormControl | undefined {
    return this.formData.formGroup?.get(
      this.formData.id,
    ) as FormControl;
  }

  public isChecked(
    value: string,
  ): boolean {
    const values = this.control?.value;

    if (!Array.isArray(values)) {
      return false;
    }

    return values.includes(value);
  }

  public onCheckboxChange(
    option: InputCheckboxListOption,
    checked: boolean,
  ): void {
    const currentValues: string[] =
      Array.isArray(this.control?.value)
        ? [...this.control.value]
        : [];

    if (checked) {
      if (!currentValues.includes(option.value)) {
        currentValues.push(option.value);
      }
    } else {
      const index = currentValues.indexOf(
        option.value,
      );

      if (index !== -1) {
        currentValues.splice(index, 1);
      }
    }

    this.control?.setValue(currentValues);
    this.control?.markAsDirty();
    this.control?.markAsTouched();
  }
}
